import React from 'react';

const CardAnimado = ({ animation, digit, css }) => {
    return (
        <div className={`flipCard ${animation}`} style={css}>
            <span>{digit}</span>
        </div>
    );
};

export default CardAnimado;